export const ALL_RUTAS = [1, 2, 3, 4, 5, 6, 7, 8];

type RutaUser = {
  role?: string;
  allowed_rutas?: number[] | null;
} | null | undefined;

export function isRutaRestricted(user: RutaUser): boolean {
  return !!user && user.role === 'manager'
    && Array.isArray(user.allowed_rutas) && user.allowed_rutas.length > 0
    && user.allowed_rutas.length < ALL_RUTAS.length;
}

export function getVisibleRutas(user: RutaUser): number[] {
  if (isRutaRestricted(user)) {
    return [...(user!.allowed_rutas as number[])].sort((a, b) => a - b);
  }
  return ALL_RUTAS;
}
